import styled from 'styled-components'

const TrackDetail = styled.div`
    > p{
      color: #33333a;
      font-size: 14px;
    }
`;


const TrackBox = styled.div`
    .rescheduleMsg{
      text-align: left;
    }
  > p {
    display: flex;
    justify-content: space-between;
    color: #00b3ff;
    font-size: 14px;
        font-family: "latobold";

    > span {
      cursor: pointer;
      display: flex;
    }
    .timerSpan {
      width: 100%;
      > div {
        flex: 1;
        justify-content: space-evenly;
      }
    }
  }
  >div{
    cursor: pointer;
  }
`
const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    svg {
      margin: 0 auto;
      z-index: 1;
      background: #f7f7f7;
    }
`
const Heading = styled.div`
  font-size: 20px;
  color: #000000;
  line-height: 25px;
  font-family: 'latobold';
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  Button {
    color: #00b3ff;
    background: #ffffff;
    font-size: 20px;
  }
`;
const Msg = styled.div`
  text-align: center;
  font-size: 18px;
  color: blue;

`
const TrackDescription = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .delivered {
      cursor:pointer;
    }
    .shipping {
      cursor:pointer;
    }
    .active {
      > button {
        background-color: #00b3ff;
      }
    }
    > div {
          display: grid;
          text-align: center;
          flex:1;
          padding : 0 5px;
      button {
        font-size: 12px;
        font-family: "latobold";
        margin: 0 auto;
        margin-top: 10px;
      }
       > p {
        font-size: 12px;
        margin-top: 4px;
        margin-bottom: 0; 
        :nth-child(2) {
          margin: 0;
        }
      }      
    }
`
const Panding = styled.p`
        color: #ff7d00 !important;
          text-transform: uppercase;
          font-size: 10px;
          `

const DeliveredSection = styled.div`
  margin-left: 50px;
  margin-right: 15px;
  > div {
    font-weight: bold;
  }
  .greenStatus {
    color: #68a107;
    padding: 2px 0;
    background: transparent;
  }
  textarea {
    width: 100%;
    border: solid 1px #eaeaea;
    padding:5px;
  }
  > p {
    width: fit-content; 
  }
  .claimRaised{
    background-color: #2ad95a1a;
    padding: 5px;
    border-radius: 3px;
    text-align: center;
    align-content: center !important;
  }
`
const RatingSection = styled.div`
  font-family: "latoregular";
  display: flex;
    gap: 10px;
    align-items: center;
    .MuiBox-root {
      margin-bottom: 0;
      padding: 4px 0px 0px 0px !important;
    }
`
const ReviewSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
      font-family: "latoregular";

    button {
        align-self: flex-end;
        margin-top: 10px;
    }
`
const DownloadBOL = styled.div`
cursor:pointer;
`

export { TrackDetail, DownloadBOL, TrackBox, TrackDescription, Heading, Panding, Icon, DeliveredSection, RatingSection, ReviewSection, Msg };